/**
 * Echo Hunt -- DB/store wrappers for the deterministic text layer (P4).
 *
 * Per the ground rules (§16.0), the parsing itself lives in the pure `Bullets.ts`/`Normalize.ts`
 * modules; this thin `*_Live.ts` wrapper is the only place that touches the journal DB rows.
 *
 * P4's dev readout (a full re-parse of the whole journal on every render) was REPLACED in P5 by the
 * cached, incremental index pass in `Index_Live.ts` -- the Corpus tab now reads `echoCorpusBullets`
 * rows rather than re-parsing the journal. What remains here is the small piece both phases share:
 * the checker options implied by the user's profile.
 */
import {GetMyEchoProfile} from "./Profiles_Live.js";
import {CheckBulletOptions} from "./Normalize.js";

/** The checker options implied by the user's profile (§4.4 banned terms, §5.5 cliché blacklist).
 * Shared by the index pass and the Corpus tab's live re-check. */
export function GetCheckOptionsFromProfile(): CheckBulletOptions {
	const profile = GetMyEchoProfile();
	return {
		bannedWords: profile?.bannedTerms ?? [],
		blacklist: (profile?.clicheBlacklist ?? []).map(a=>a.phrase),
	};
}
